export const safeJSONParse = string => {
  try {
    return JSON.parse(string)
  } catch (err) {
    return {
      details: string
    }
  }
}
